<template>
  <div>
    <h2><i>Facebook</i></h2>

    <section>
      <div class="row">
        <div class="col-1"><div class="img h1"></div></div>
        <div class="col-11">
          <div class="row">
            <div class="col-12"><i><b>Facebook Name</b><br/> Age of Post</i><br/><br/></div>
            <div class="col-12">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. @ImpactJournals Aenean euismod bibendum laoreet.
              Proin gravida dolor sit amet lacus accumsan et viverra justo commodo. Proin sodales pulvinar tempor.<br/><br/>
            </div>
            <div class="col-xs-12 col-md-8"><div class="img h2"></div></div>
            <div class="col-12">
              <h5><i>Post Headline</i></h5>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. @ImpactJournals Aenean euismod bibendum laoreet.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</template>
<script>
  export default {
    name: 'media',
    data () {
      return {
      }
    },
    created () {
      this.$parent.$parent.prevPage = {name: 'article-interact'}
      this.$parent.$parent.nextPage = false
      this.$parent.$parent.prevSlide = {name: 'article-media-twitter'}
      this.$parent.$parent.nextSlide = {name: 'article-media-youtube'}
    }
  }
</script>


<style scoped lang="scss">
  .title {
    color: $primary-color;
    font-size: 32px;
  }
  section {
    margin: 20px auto;
    padding-bottom: 12px;
  &:not(:last-child) {
     border-bottom: 1px solid #cccccc;
   }
  .img {
    border: 1px solid #cccccc;
    background-color: #eeeeee;
    width: 100%;
  &.h1 {
     height: 160px;
   }
  &.h2 {
     height: calc(320px + 0.5rem);
   }
  &.h3 {
     height: calc(480px + 1rem);
   }
  }
  .col-1 {
    flex:  0 0 190px;
    max-width: 190px;
  }
  .col-11 {
    flex: calc(100% - 190px);
    max-width: calc(100% - 190px);
  }
  }
</style>



// WEBPACK FOOTER //
// MediaFacebookPage.vue?06ff9da6